var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"status":"401","title":"Unauthorized"}},[_c('p',[_vm._v("\n\t\tSign in and try again.\n\t")]),_vm._v(" "),_c('btn',{attrs:{"primary":"","raised":"","to":{ name: 'login' }}},[_vm._v("Sign in")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }